<template>
  <div class="px-8" v-if="modelValue">
    <div class="font-weight-medium text-uppercase my-4 mb-0">custom url</div>
    <v-text-field v-model="modelValue.settings.customUrl" hide-details :disabled="disableInput"></v-text-field>
  </div>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  selectedPlacement: string,
  make: string,
  model: string,
  disableInput : boolean
}>()

const settingsStore = useSettingsStore();
const modelValue = ref()

onMounted(() => {
  modelValue.value = settingsStore.placements.placements[props.selectedPlacement]['filter'].find((item: any) => {
    return item.make === props.make && item.model === props.model
  })
})


</script>
